import { createSlice } from '@reduxjs/toolkit';

// Icon imports for store
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PeopleIcon from "@mui/icons-material/People";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

// Initial state with all data from Home component
const initialState = {
  hero: {
    title: "Designs that breathe, spaces that speak",
    subtitle: "Momentsia Design Studio is a full-service interior design studio creating premium residential and commercial spaces that balance luxury, warmth, and functionality. From concept to execution, every design is tailored to feel personal, timeless, and practical — not loud, not copied.",
    backgroundImage: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
    badge: "Award Winning Design Studio Since 2010",
    // highlights: [
    //   { 
    //     text: "Extended Warranty", 
    //     icon: <VerifiedUserIcon sx={{ fontSize: 20, color: "#FF6B35" }} />, 
    //     color: "#FF6B35" 
    //   },
    //   { 
    //     text: "Transparent Pricing", 
    //     icon: <LocalOfferIcon sx={{ fontSize: 20,  color: "#FF6B35" }} />, 
    //      color: "#FF6B35"
    //   },
    //   { 
    //     text: "Expert Design Team", 
    //     icon: <PeopleIcon sx={{ fontSize: 20,  color: "#FF6B35" }} />, 
    //      color: "#FF6B35" 
    //   }
    // ]
  },

  stats: [
    {
      value: "99.5%",
      label: "Client Satisfaction",
      icon: <ThumbUpIcon />,
       color: "#FF6B35"
    },
    {
      value: "8+",
      label: "Years Experience",
      icon: <CalendarTodayIcon />,
       color: "#FF6B35"
    },
    {
      value: "80+",
      label: "Projects Completed",
      icon: <CheckCircleIcon />,
      color: "#FF6B35"
    }
  ],

  // Services Data
  services: [
    {
      id: 1,
      title: "Residential Design",
      description: "Beautiful homes that reflect your personality and lifestyle",
      image: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <HomeIcon sx={{ color: "#FF6B35" }} />,
      features: ["Custom Interiors", "Space Planning", "Furniture Selection"],
      color: "#FF6B35"
    },
    {
      id: 2,
      title: "Commercial Spaces",
      description: "Professional workspaces that inspire productivity and creativity",
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <BusinessIcon sx={{  color: "#FF6B35" }} />,
      features: ["Office Design Athentic", "New Retail Spaces", "Hospitality"],
      color: "#FF6B35"
    },
    {
      id: 3,
      title: "Renovation",
      description: "Complete interior solutions for every room in your space",
      image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <DesignServicesIcon sx={{  color: "#FF6B35" }} />,
      features: ["Color Schemes", "Lighting Design", "Decor Selection"],
       color: "#FF6B35"
    },
    {
      id: 4,
      title: "New Project",
      description: "Complete interior solutions for every room in your space",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <DesignServicesIcon sx={{  color: "#FF6B35" }} />,
      features: ["Color Schemes", "Lighting Design", "Decor Selection"],
       color: "#FF6B35"
    }
  ],

  processSteps: [
    {
      step: "01",
      title: "Consultation",
      description: "Free design consultation",
      active: false
    },
    {
      step: "02",
      title: "Planning",
      description: "Space planning & 3D design",
      active: false
    },
    {
      step: "03",
      title: "Design",
      description: "Material & furniture selection",
      active: false
    },
    {
      step: "04",
      title: "Execution",
      description: "Professional implementation",
      active: false
    },
    {
      step: "05",
      title: "Handover",
      description: "Final walkthrough & keys",
      active: false
    }
  ],

  featuredProjects: [
    {
      id: 1,
      title: "Modern Luxury Villa",
      location: "Miami, Florida",
      type: "Residential",
      duration: "4 Months",
      rating: 4.9,
      highlights: ["Smart Home", "Minimalist Design", "Sustainable Materials"]
    },
    {
      id: 2,
      title: "Tech Hub Office",
      location: "San Francisco, CA",
      type: "Commercial",
      image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      duration: "6 Months",
      rating: 4.8,
      highlights: ["Collaborative Spaces", "Eco-Friendly", "Modern Aesthetics"]
    },
    {
      id: 3,
      title: "Boutique Hotel",
      location: "Austin, Texas",
      type: "Hospitality",
      image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      duration: "8 Months",
      rating: 5.0,
      highlights: ["Luxury Suites", "Spa Design", "Landscape Integration"]
    }
  ],

  faqs: [
     {
      id: 1,
      question: "How much your service cost and how do you set a project budget ?",
      answer: "Costs vary based on your project scope, but here's our promise: complete transparency, no surprises. We offer tiered packages starting from $X,XXX, and during our free consultation, we'll help you set a realistic budget that aligns with your goals while maximizing your investment. Think of it as smart spending—not just spending.",
      icon: <ScheduleIcon />,
      color: "#88370bff"
    },
     {
      id: 2,
      question: "How long the entire process take from designing to handover?",
      answer: "While most projects take 8-16 weeks, we customize timelines based on your needs. Some clients prefer a 4-week express package for key areas, while others enjoy a 20-week journey for whole-home transformations. We'll work at your pace—whether you want it done quickly or prefer a more gradual approach.",
      icon: <ScheduleIcon />,
      color: "#9f5b1c42"
    },
     {
      id: 3,
      question: "How involved do I need to be and how will you take the meetings?",
      answer: "Your involvement is entirely up to you! We recommend being part of the fun parts—selecting finishes, approving designs, and the final reveal. We handle all the complex coordination.Meetings are scheduled at your convenience (evenings/weekends available), kept efficient (30-60 mins), and always have clear agendas. You'll never waste time in unnecessary meetings.",
      icon: <ScheduleIcon />,
      color: "#291356ff"
    },
     {
      id: 4,
      question: "How will you understand my design perspective?",
      answer: "We believe your design perspective emerges through collaboration, not interrogation. We'll present multiple options for each element, observing what you're drawn to. It's like fitting pieces of a puzzle—we start broad (overall aesthetic) and refine (specific materials, layouts) based on your reactions. You'll know we 'get it' when you see designs that feel unmistakably you.",
      icon: <ScheduleIcon />,
      color: "#361634ff"
    },
     {
      id: 5,
      question: "What about the quality of the material you use and what if any changes or damage happen?",
      answer: "Quality We use materials that balance beauty with durability—think stain-resistant fabrics, scratch-proof surfaces, and commercial-grade finishes where it matters. You'll approve every selection, and we share product warranties upfront. Changes/Damage: We build flexibility into our process. Want to switch a paint color mid-project? No problem—we have a simple change process. If anything gets damaged during installation, we replace it immediately at our cost. After completion, we offer a 60-day 'peace of mind' period where we fix any issues, no questions asked.",
      icon: <ScheduleIcon />,
      color: "#071719ff"
    },
    {
      id: 6,
      question: "How involved do I need to be in the design process?",
      answer: "Project timelines vary based on scope and complexity. A single room redesign typically takes 4-6 weeks, while full-home projects take 3-6 months from concept to completion. We provide a detailed timeline during our initial consultation and maintain regular progress updates throughout the project.",
      icon: <ScheduleIcon />,
      color: "#008C9E"
    },
    {
      id: 7,
      question: "What is your pricing structure?",
      answer: "We offer flexible pricing options: hourly rates for consultations and smaller projects, flat fees for complete room designs, or cost-plus percentage for large renovations and full-home projects. All pricing is transparent with detailed breakdowns and no hidden costs. Book a free consultation to get a personalized quote based on your specific needs.",
      icon: <LocalOfferIcon />,
      color: "#FF6B35"
    },
    {
      id: 8,
      question: "Do you work with existing furniture and decor?",
      answer: "Absolutely! We believe in sustainable design and love incorporating existing pieces whenever possible. During our consultation, we assess what works in your current space and recommend updates, reupholstering, or strategic new purchases to complete your vision while staying within budget.",
      icon: <HomeIcon />,
      color: "#1D3557"
    },
    {
      id: 9,
      question: "How involved do I need to be in the design process?",
      answer: "As involved as you want to be! Some clients prefer a hands-off approach while others enjoy being part of every decision. We adapt to your preferred level of involvement and provide regular updates, presentations, and opportunities for feedback at each stage of the project.",
      icon: <PeopleIcon />,
      color: "#695424ff"
    },
    {
      id: 10,
      question: "Do you handle project management and contractor coordination?",
      answer: "Yes, we offer full-service project management. We coordinate with contractors, architects, and vendors, oversee installations, manage timelines, and ensure quality control. This comprehensive service ensures a seamless experience from concept to completion.",
      icon: <DesignServicesIcon />,
      color: "#162841ff"
    },
    {
      id: 11,
      question: "What areas do you serve?",
      answer: "We primarily serve the metropolitan area and surrounding regions. For large commercial projects or out-of-area clients, we offer virtual design services with the same attention to detail. Contact us to discuss your location and project requirements.",
      icon: <LocationOnIcon />,
      color: "#5f6f85ff"
    },
    {
      id: 12,
      question: "Can I see 3D renderings before work begins?",
      answer: "Yes! We provide detailed 3D renderings and virtual walkthroughs for all projects. This allows you to visualize the final result, make adjustments, and feel confident about the design direction before any physical work begins.",
      icon: <CheckCircleIcon />,
      color: "#008C9E"
    },
    {
      id: 13,
      question: "What is your warranty or guarantee policy?",
      answer: "We offer a 2-year warranty on all our design work and stand behind the quality of our recommended products and contractors. Additionally, we provide post-completion support to ensure you're completely satisfied with your new space.",
      icon: <VerifiedUserIcon />,
      color: "#FF6B35"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Homeowner, New York",
      rating: 5,
      comment: "Momentsia transformed our apartment into a dream home. Their attention to detail was incredible!",
      avatar: "SJ",
      project: "3BHK Apartment Renovation"
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "CEO, Tech Startup",
      rating: 5,
      comment: "Our office design boosted employee morale by 40%. Professional team with amazing results.",
      avatar: "MC",
      project: "Corporate Office Design"
    },
    {
      id: 3,
      name: "Priya Sharma",
      role: "Restaurant Owner",
      rating: 5,
      comment: "The restaurant design attracted 60% more customers. Worth every penny!",
      avatar: "PS",
      project: "Fine Dining Restaurant"
    }
  ],
  cta: {
    title: "Ready to Transform Your Space?",
    subtitle: "Get a free design consultation with our experts. No commitment, just great advice.",
    phone: "+91 83708 25457",
    features: [
      "No Hidden Charges"
    ]
  },

  // UI State
  loading: false,
  error: null,
  activeProcessStep: 0,
  expandedFaqs: []
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    // Set active process step
    setActiveProcessStep: (state, action) => {
      state.activeProcessStep = action.payload;
      // Update all process steps active state
      state.processSteps = state.processSteps.map((step, index) => ({
        ...step,
        active: index <= action.payload
      }));
    },

    // Toggle FAQ expansion
    toggleFaq: (state, action) => {
      const faqId = action.payload;
      const index = state.expandedFaqs.indexOf(faqId);
      if (index > -1) {
        state.expandedFaqs.splice(index, 1);
      } else {
        state.expandedFaqs.push(faqId);
      }
    },

    // Expand all FAQs
    expandAllFaqs: (state) => {
      state.expandedFaqs = state.faqs.map(faq => faq.id);
    },

    // Collapse all FAQs
    collapseAllFaqs: (state) => {
      state.expandedFaqs = [];
    },

    // Update hero data
    updateHeroData: (state, action) => {
      state.hero = { ...state.hero, ...action.payload };
    },

    // Update services
    updateServices: (state, action) => {
      state.services = action.payload;
    },

    // Update featured projects
    updateFeaturedProjects: (state, action) => {
      state.featuredProjects = action.payload;
    },

    // Update testimonials
    updateTestimonials: (state, action) => {
      state.testimonials = action.payload;
    },

    // Update FAQs
    updateFaqs: (state, action) => {
      state.faqs = action.payload;
    },

    // Update stats
    updateStats: (state, action) => {
      state.stats = action.payload;
    },

    // Update process steps
    updateProcessSteps: (state, action) => {
      state.processSteps = action.payload;
    },

    // Update CTA
    updateCta: (state, action) => {
      state.cta = { ...state.cta, ...action.payload };
    },

    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error
    setError: (state, action) => {
      state.error = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Reset to initial state
    resetHomeData: (state) => {
      return initialState;
    }
  }
});

export const {
  setActiveProcessStep,
  toggleFaq,
  expandAllFaqs,
  collapseAllFaqs,
  updateHeroData,
  updateServices,
  updateFeaturedProjects,
  updateTestimonials,
  updateFaqs,
  updateStats,
  updateProcessSteps,
  updateCta,
  setLoading,
  setError,
  clearError,
  resetHomeData
} = homeSlice.actions;

export default homeSlice.reducer;